export class DomValidationError extends Error {
  constructor(errorCode) {
    super(errorCode)
    this.name = 'DomValidationError'
  }
}
